const getFileNameUrlMapping = (storiesRequire: () => __WebpackModuleApi.RequireContext) => {

  return storiesRequire().keys().reduce((result, iconPath) => {
    const fileName = iconPath.replace(/.*\//, '').replace(/\..*/, '')
    const iconUrl = storiesRequire()(iconPath)

    return {
      ...result,
      [fileName]: iconUrl.default || iconUrl
    }
  }, {} as Record<string, string>)
}

export default getFileNameUrlMapping
